import {
  UnarchiveIcon_default
} from "./chunk-MA3IPU6H.mjs";
export {
  UnarchiveIcon_default as default
};
